// Mock data for Molentis S.A

export const companyInfo = {
  name: "Molentis S.A",
  shortName: "Molentis",
  email: "info@molentis-sa.com",
  hours: "Mon - Fri, 10:00 - 18:00",
  address: "41 Bd Royal, L-2449 Ville-Haute, Luxembourg",
  registeredOffice: "106 Route d'Esch, L-1470 Luxembourg",
  companyNumber: "B209995",
  crefoNumber: "9370288615",
  incorporationDate: "03 November 2016",
  jurisdiction: "Luxembourg",
};

// Editorial image library — Luxembourg City skyline, architecture & luxury private-banking interiors
export const images = {
  // Luxembourg City — authentic skyline, Kirchberg business district, Grund & old town
  luxSkyline: "https://images.unsplash.com/photo-1717940900954-77aa9172d342?w=1920&q=80",
  luxKirchberg: "https://images.unsplash.com/photo-1592571169485-cda6ca8a05ac?w=1920&q=80",
  luxOldTown: "https://images.unsplash.com/photo-1588336899284-950764f07147?w=1920&q=80",
  luxAerial: "https://images.unsplash.com/photo-1727793737440-d577f07394dc?w=1920&q=80",
  luxAdolpheBridge: "https://images.unsplash.com/photo-1590337828257-b13c65643bdc?w=1920&q=80",
  luxGrund: "https://images.unsplash.com/photo-1662239936406-522b4f82546a?w=1920&q=80",
  luxNight: "https://images.unsplash.com/photo-1633106314174-5a6bd7e8955e?w=1920&q=80",
  luxHeritage: "https://images.unsplash.com/photo-1588336899745-22da91d8f816?w=1920&q=80",
  europeanFacade: "https://images.unsplash.com/photo-1616778504617-11615e3ceff7?w=1920&q=80",
  historicArchway: "https://images.unsplash.com/photo-1592770733110-738f7769188c?w=1920&q=80",
  stoneStreet: "https://images.unsplash.com/photo-1681300011982-5f01aca8b5d6?w=1920&q=80",

  // Executive interiors & boardrooms
  boardroom: "https://images.unsplash.com/photo-1587560699334-cc4ff634909a?w=1920&q=80",
  executiveOffice: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&q=80",
  privateOffice: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80",
  luxuryInterior: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80",

  // Wood, marble, stone details
  classicalLibrary: "https://images.unsplash.com/photo-1519452575417-564c1401ecc0?w=1920&q=80",
  woodPaneledLibrary: "https://images.unsplash.com/photo-1568667256549-094345857637?w=1920&q=80",
  marbleColumns: "https://images.unsplash.com/photo-1580977276076-ae4b8c219b8e?w=1920&q=80",
  marbleStair: "https://images.pexels.com/photos/2102546/pexels-photo-2102546.jpeg?w=1920",

  // Professionals in suits — refined, discreet
  advisoryDiscussion: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=80",
  executiveMeeting: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=1920&q=80",
  suitedExecutive: "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1920&q=80",

  // Warm, bright & welcoming interiors — used for Services cards
  warmMeetingRoom: "https://images.unsplash.com/photo-1710956394109-aaa3710e3a63?w=1920&q=80",
  warmOffice: "https://images.unsplash.com/photo-1764410481612-7544525b2991?w=1920&q=80",
  warmStudy: "https://images.unsplash.com/photo-1663006895289-37cfd433f00d?w=1920&q=80",
  warmSuite: "https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?w=1920&q=80",
  warmLounge: "https://images.unsplash.com/photo-1615580027287-1e190512bde3?w=1920&q=80",
  warmDesk: "https://images.unsplash.com/photo-1716550252758-cd835ac02276?w=1920&q=80",
  warmReading: "https://images.unsplash.com/photo-1640719841542-e56205598311?w=1920&q=80",

  // Thematic warm imagery — mapped to each service
  themeAdvisorMeeting: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1920&q=80",
  themeTaxDocuments: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1920&q=80",
  themeGrowthCoins: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1920&q=80",
  themeBoardroomWood: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?w=1920&q=80",
  themeHandshakeWood: "https://images.unsplash.com/photo-1638262052640-82e94d64664a?w=1920&q=80",
  themeGoldBars: "https://images.unsplash.com/photo-1610375461246-83df859d849d?w=1920&q=80",
};

export const heroSlides = [
  {
    tagline: "Family Office · Luxembourg",
    title: "Finance Without Limits.",
    description: "An independent family office dedicated to wealth management, asset protection and international tax planning for high-net-worth families across Luxembourg and the European Union.",
    image: images.luxSkyline,
  },
  {
    tagline: "Wealth Management · Estate Planning",
    title: "Optimize Your Capital.",
    description: "Bespoke wealth management, estate planning and cross-generational stewardship — designed to preserve and grow your family's capital with discretion.",
    image: images.luxAdolpheBridge,
  },
  {
    tagline: "Corporate Structuring · International Tax Planning",
    title: "Protect & Grow Your Wealth.",
    description: "Corporate structuring and international tax planning for entrepreneurs, private investors and multi-jurisdictional groups — grounded in compliance and long-term resilience.",
    image: images.luxKirchberg,
  },
];

export const highlights = [
  { icon: "Clock", title: "On-Time Service", text: "Experience the reliability of our service, ensuring prompt and efficient solutions tailored to meet your wealth needs." },
  { icon: "Users", title: "A Team of Professionals", text: "Benefit from the expertise of our dedicated team of professionals, committed to delivering top-notch tailored solutions with precision and insight." },
  { icon: "LineChart", title: "Analyze Your Business", text: "Uncover strategic insights and elevate your business performance with our specialised team, dedicated to thoroughly analysing your business for informed decision-making." },
];

export const partners = [
  { name: "HSBC",                     logo: "/partners/hsbc.svg" },
  { name: "BNP Paribas",              logo: "/partners/bnp-paribas.svg" },
  { name: "Pictet",                   logo: "/partners/pictet.svg" },
  { name: "Edmond de Rothschild",     logo: "/partners/rothschild.svg" },
  { name: "Lombard Odier",            logo: "/partners/lombard-odier.png" },
  { name: "J. Safra Sarasin",         logo: "/partners/j-safra-sarasin.png" },
  { name: "Quintet Private Bank",     logo: "/partners/quintet.svg" },
  { name: "Banque de Luxembourg",     logo: "/partners/banque-de-luxembourg.png" },
  { name: "Banque Internationale à Luxembourg", logo: "/partners/bil.svg" },
];

export const services = [
  {
    slug: "tax-optimization",
    icon: "Scale",
    image: images.themeTaxDocuments,
    title: "Tax Optimization",
    short: "Discreet, compliant strategies for long-term tax efficiency.",
    description: "Our Tax Optimization service helps individuals, families and corporate groups design lawful, sustainable strategies that preserve wealth across generations and across borders. We work exclusively within the framework of applicable laws, in full transparency with competent authorities.",
    longDescription: "In coordination with your existing legal and tax counsels — or through our trusted network when needed — we assess your global situation and design frameworks that reconcile efficiency, resilience and reputation. Every recommendation is documented, justifiable and built to last.",
    benefits: [
      { title: "Predictable Effective Rate", text: "A clear, sustainable tax profile aligned with your long-term projections." },
      { title: "Cross-Border Compatibility", text: "Structures compatible with the jurisdictions where you live, invest and hold assets." },
      { title: "Asset Protection", text: "Robust vehicles that protect wealth against non-financial risks — while respecting the law." },
      { title: "Succession Efficiency", text: "Smooth intergenerational transfer aligned with civil-law and family charters." },
      { title: "Full Transparency", text: "Compliance-first approach with clear reporting to relevant authorities." },
      { title: "Documented Rationale", text: "Every decision supported by a written economic and legal rationale." },
    ],
    approach: [
      { n: "01", title: "Confidential Discovery", text: "A private conversation to understand your family, business and cross-border footprint." },
      { n: "02", title: "Comprehensive Diagnostic", text: "Mapping of assets, jurisdictions, existing structures and applicable frameworks." },
      { n: "03", title: "Bespoke Design", text: "A tailored architecture designed with your existing advisors — lawyers, notaries, tax counsels." },
      { n: "04", title: "Discreet Implementation", text: "Structured, staged execution with clear ownership at every step." },
      { n: "05", title: "Ongoing Stewardship", text: "Annual reviews aligned with regulatory changes and life events." },
    ],
    faqs: [
      { q: "Is tax optimization legal?", a: "Yes. Tax optimization refers to the lawful arrangement of one's affairs to reduce tax liability within the framework of applicable laws. It is fundamentally different from tax evasion, which is illegal. Every strategy we design is fully compliant and transparent with relevant authorities." },
      { q: "Do you work with my existing lawyer and tax advisor?", a: "Absolutely. We are advisors, not gatekeepers. We regularly coordinate with our clients' existing lawyers, notaries and tax specialists — and can introduce trusted counsels when a client does not yet have them." },
      { q: "Which jurisdictions do you cover?", a: "Our focus is Luxembourg and the European Union, with active experience across the United Kingdom, France, Belgium, and selected non-EU jurisdictions. Cross-border cases are our daily reality." },
      { q: "What is the typical engagement duration?", a: "A first-time structuring engagement typically spans three to six months, followed by an annual review. Complex cross-border situations may require longer initial mandates." },
      { q: "How is confidentiality guaranteed?", a: "Strict internal controls, need-to-know access, encrypted channels and, when appropriate, non-disclosure agreements protect every engagement. Our team is bound by strict professional obligations." },
    ],
  },
  {
    slug: "wealth-management",
    icon: "Wallet",
    image: images.themeAdvisorMeeting,
    title: "Wealth Management",
    short: "Personalised portfolios and disciplined stewardship across generations.",
    description: "From life planning to institutional-grade portfolio construction, we design wealth strategies around your priorities — not markets alone. Whether you are building, preserving or transferring capital, our advisors combine advisory and discretionary mandates to keep your capital working with clarity, discipline and long-term conviction.",
    longDescription: "We build portfolios that endure. Combining top-down macro views with bottom-up security research, we blend traditional assets with alternatives — private equity, private credit and real assets — and manage risk actively, faithful to your investment philosophy and time horizon. Reporting is transparent, discretion is absolute, and every mandate is anchored in a written investment charter.",
    features: [
      { title: "Life Planning", text: "Long-term projections aligning investments with education, retirement and legacy goals." },
      { title: "Strategic Allocation", text: "Diversified allocations across equities, fixed income, real assets and alternatives — reviewed against evolving macro and personal factors." },
      { title: "Discretionary & Advisory Mandates", text: "Delegate day-to-day decisions to senior advisors bound by your investment charter, or keep a hands-on advisory relationship." },
      { title: "Active Risk Management", text: "Volatility, drawdown and liquidity controls integrated at portfolio and position level." },
      { title: "Alternatives Access", text: "Curated access to private equity, private credit and real assets alongside listed markets." },
      { title: "Succession Planning", text: "Seamless wealth transfer through trusts, foundations and tailored governance, coordinated with your legal counsels." },
    ],
  },
  {
    slug: "international-structuring",
    icon: "Globe2",
    image: images.luxKirchberg,
    title: "International Structuring",
    short: "Cross-border architecture designed with care and precision.",
    description: "For internationally mobile families, entrepreneurs and corporate groups, we design and coordinate cross-border structures that reconcile efficiency, substance and long-term resilience. Every recommendation is validated with your legal and tax counsels.",
    longDescription: "From holding vehicles to family investment companies, our specialists work with a trusted network of lawyers, notaries and tax advisers to design structures that fit your reality — respecting regulatory expectations in every jurisdiction involved.",
    features: [
      { title: "Holding Structures", text: "Luxembourg SOPARFIs and international holdings aligned with your business footprint." },
      { title: "Family Investment Vehicles", text: "SPFs, SICAV-RAIFs and comparable vehicles for private wealth structuring." },
      { title: "Substance & Governance", text: "Board composition, decision-making processes and reporting fit for modern scrutiny." },
      { title: "Redomiciliation", text: "Assisted relocation of vehicles or investors to jurisdictions that match your priorities." },
    ],
  },
  {
    slug: "financing-solutions",
    icon: "Landmark",
    image: images.themeBoardroomWood,
    title: "Financing Solutions",
    short: "Tailored financing for entrepreneurs, families and corporate groups.",
    description: "We help private clients, entrepreneurs and companies access the right financing at every stage of their growth. From acquisition finance and real estate leverage to bond issuances, private placements and syndicated loans, we structure and negotiate solutions that match your cash-flow, timing and risk profile.",
    longDescription: "Working alongside our network of banks, private lenders and institutional investors, we identify optimal financing structures, coordinate with legal and regulatory teams, and close transactions efficiently — whether it is a first bond issuance, a refinancing, an acquisition line, or a hybrid instrument. Our advisors sit next to you throughout the entire process, from mandate to drawdown.",
    features: [
      { title: "Debt Advisory", text: "Bond issuances, syndicated loans and private placements structured to match your cash-flow profile." },
      { title: "Acquisition & Real Estate Finance", text: "Leverage solutions for corporate acquisitions, real estate deals and family wealth structuring." },
      { title: "Refinancing & Restructuring", text: "Balance-sheet optimisation and refinancing strategies at pivotal moments." },
      { title: "Rating & Lender Relations", text: "Preparation for credit rating agencies and ongoing dialogue with lenders to protect your credit profile." },
    ],
  },
];

export const stats = [
  { value: "2016", label: "Founded" },
  { value: "€31,000", label: "Share Capital" },
  { value: "€150,000,000+", label: "Financed Year-to-Date" },
  { value: "10+", label: "Years of Experience" },
  { value: "100%", label: "Independent" },
];

export const advantages = [
  "Premium services beyond your expectations",
  "Best-in-class support among all vendors",
  "Fully responsive and works great on all major devices",
  "Comprehensive, transparent reporting tools",
];

export const whatSetsUsApart = [
  "We offer a genuinely personal service and innovative, customised solutions.",
  "Our size and independence make us ideally placed to support our clients.",
  "We invest in state-of-the-art risk analysis technology and practices.",
  "Our analytics and cascading models are industry-leading and award-winning.",
  "We have over 90 percent client retention rate.",
];

export const testimonials = [
  {
    quote: "Working with Molentis has been an absolute game-changer for our company. Their expertise and dedication to our success have surpassed our expectations. With their guidance, we've been able to navigate turbulent economic waters and emerge stronger than ever. Molentis is more than just a service provider; they're a trusted partner in our journey towards achieving our long-term goals.",
    author: "Walt Whitman",
    role: "CEO, Press Mag",
    initials: "WW",
  },
  {
    quote: "I can't speak highly enough of the team at Molentis. From the moment we engaged with them, their professionalism and commitment to excellence were evident. They took the time to understand our unique needs and delivered tailored solutions that exceeded our expectations. Thanks to their expertise, we've been able to streamline our operations and drive significant growth.",
    author: "Ann Wroe",
    role: "Journalist",
    initials: "AW",
  },
  {
    quote: "Molentis has become an invaluable long-term partner. Their thoughtful strategy and honest communication have helped us streamline operations and drive sustainable growth for the last several years.",
    author: "Marc Delacroix",
    role: "Founder, Delacroix Capital",
    initials: "MD",
  },
];

export const team = [
  { name: "Nicolas Rupert", role: "Chief Executive Officer", email: "n.rupert@molentis-sa.com" },
  { name: "Avelino Da Costa", role: "General Director", email: "a.dacosta@molentis-sa.com" },
  { name: "Franck Costa", role: "General Manager", email: "f.costa@molentis-sa.com" },
  { name: "Jerome Costa", role: "Financial Director", email: "j.costa@molentis-sa.com" },
  { name: "Edouard Leyen", role: "Manager", email: "e.leyen@molentis-sa.com" },
  { name: "Alain Bartholome", role: "Manager", email: "a.bartholome@molentis-sa.com" },
  { name: "Rachel Clauss", role: "Assistant Manager", email: "r.clauss@molentis-sa.com" },
  { name: "Sara Legrand", role: "Assistant Manager", email: "s.legrand@molentis-sa.com" },
];

export const faqs = [
  { q: "How do I get started with Molentis?", a: "Reach out via our contact form or by email. A senior advisor will get back to you within 1-2 working days to schedule a confidential introductory call." },
  { q: "Do you work with international clients?", a: "Yes. Based in Luxembourg, we serve individuals, families and companies across Europe and beyond, with cross-border expertise built into every engagement." },
  { q: "What is the minimum investment amount?", a: "Minimum thresholds vary by service. Wealth-advisory mandates typically start from EUR 250,000, while corporate advisory work is scoped on a case-by-case basis." },
  { q: "Are you a regulated entity?", a: "Molentis S.A is registered in Luxembourg under company number B209995 and operates within the regulatory framework of the Grand Duchy of Luxembourg." },
  { q: "How do you protect client confidentiality?", a: "Strict internal controls, need-to-know access, encrypted communication channels and, where relevant, non-disclosure agreements protect every client engagement." },
  { q: "Can you coordinate with my existing advisors?", a: "Absolutely. We regularly work alongside lawyers, tax advisors, notaries and family offices to deliver seamless outcomes for our clients." },
];

export const positions = [
  { title: "Senior Wealth Advisor", location: "Luxembourg", type: "Full-time", team: "Wealth Management" },
  { title: "Corporate Finance Analyst", location: "Luxembourg", type: "Full-time", team: "Capital Markets" },
  { title: "International Tax Associate", location: "Luxembourg / Paris", type: "Full-time", team: "Tax Optimization" },
  { title: "Compliance Officer", location: "Luxembourg", type: "Full-time", team: "Risk & Compliance" },
  { title: "Client Relationship Manager", location: "Luxembourg", type: "Full-time", team: "Client Service" },
  { title: "Summer Intern — Analyst", location: "Luxembourg", type: "Internship", team: "Rotational" },
];

export const careerValues = [
  { title: "Integrity above all", text: "We say what we do and do what we say. Our reputation is built one honest conversation at a time." },
  { title: "Craft over noise", text: "We prize precision, discretion and depth over trends. Every deliverable is finished with care." },
  { title: "Team-first mindset", text: "Great work happens when senior and junior colleagues learn from each other every day." },
  { title: "Long-term thinking", text: "We invest in people the way we invest for our clients — patiently and with conviction." },
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: services.map((s) => ({ label: s.title, to: `/services/${s.slug}` })),
  },
  { label: "Careers", to: "/careers" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
